import React, { Component } from "react";
import "./styles.css";

class Loader extends Component {

  // ===============================================================================================
  render() {
    let loaderText = null;

    if (this.props.text) {
      loaderText = (
        <span className="loading-burst__text">Loading</span>
      );
    }

    return (
      <div className={"loading-burst" +
        ((this.props.className) ? " " + this.props.className : "")}>

        <div className="loading-burst__wrapper">

          <div className={"loading-burst__anim" +
            ((this.props.theme) ?  " loading-burst__anim--theme-" + this.props.theme : "") +
            ((this.props.type)  ?  " loading-burst__anim--type-"  + this.props.type  : "")}>
          </div>

          {loaderText}

        </div>

      </div>
    );
  }

}



export default Loader
